import dayjs from "dayjs";

export const configuration = {
    quote: {
        ordinaryAge:process.env.QUOTE_ORDINARY_AGE,
        ordinary:process.env.QUOTE_ORDINARY_VALUE,
        default:'0',
        pressSustain: 10
    },
    none:'NONE',
    empty:'',
    noIndex:-1,

    yn: {
        yes:'STATUS_YES',
        no:'STATUS_NO'
    },
    
    motive: {
        work: 'MOTIVO-LAVORO',
        study: 'MOTIVO-STUDIO',
        town: 'MOTIVO-RESIDENZA'
    },
    gender: {
        male: 'M',
        female: 'F',
        noAnswer: 'N'
    },
    payments: {
        paypal: 'PAYPAL',
        credictCard: 'CCARD',
        bankWire: 'BANK'
    },
    maxFileSize:'7',
    phoneCode:'+39',
    requiredChar:' *',
    
    //previousYear:new Date().getFullYear()-1,
    //displayYear:new Date().getFullYear(),
    previousYear: dayjs().year()-1,
    displayYear: dayjs().year(),

    emailPattern: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    minDate:'1970-01-01',
    currentLocaleDate: document.documentElement.lang, // Intl.DateTimeFormat().resolvedOptions().locale,
    currentAppLocale: document.documentElement.lang,
    acceptedFileFormats:'.png, .jpg, .jpeg, .pdf, .doc, .docx',
    currentLocaleDateOptions: {
        weekday: 'long',
        year: 'numeric',
        month: 'long',
        day: 'numeric',
    }
    
    , moment: {
        localeDateString: 'DD/MM/YYYY'
        , localeDateTimeString: 'DD/MM/YYYY H:mm:ss'
        , formControlDateString: 'YYYY-MM-DD'
    }

    , defaultLinkTimeout: 150
    , floatRegExp: new RegExp('^[+-]?([0-9]+([.][0-9]*)?|[.][0-9]+)$')
    , acceptedEventExportFileFormats:'.json'
    
};

export const app = {
    name: 'EuropaVerdi Tesseramento' //process.env.APP_NAME
    , alias: process.env.APP_ALIAS
    , logo: '/storage/assets/logo.png'
    , backgroundImage: 'images/background.png'
    , backgroundOpacityLayer: 'rgba(0, 0, 0, 0.6)'
    , title: process.env.APP_NAME
    , mainRowPadding: 30
    , secret_key: process.env.APP_KEY
    , inactivityTimeOut: (8 * 60 * 60 * 1000)               // 08 h
    , inactivityCountdown: (15)                             // 15 s
    , coockieTimeOut: (8 * 60 * 60 * 1000)                  // 08 h

    // β - 0.23.20250429
    // β - 0.24.20250429
    // β - 0.30.20250506
    // β - 0.31.20250507 | β - 0.32.20250507 | β - 0.33.20250507 | β - 0.38.20250507 | β - 0.39.20250507 | β - 0.41.20250507
    // β - 0.72.20250523
    // β - 0.272.20250903 prima implementazione email template
    // β - 0.434.20260303
    // β - 0.454.20260326
    // 1.0.8.455
    // 1.0.9.463
    // 1.0.10.465
    // 1.1.0.491
    // 1.1.0.492
    // 1.1.0.493
    // 1.1.0.494
    // 1.1.0.495
    // 1.1.0.496
    // 1.1.0.497
    // 1.1.0.498
    // 1.1.0.499
    // 1.1.0.500
    // 1.1.0.501
    // 1.1.0.502
    // 1.1.0.503
    // 1.1.0.504
    // 1.1.0.505
    // 1.1.0.506 (revertata)
    // 1.1.0.507
    // 1.1.0.508
    // 1.1.0.509
    // 1.1.0.510
    // 1.1.0.511 (fix select Professione non affidabile, sostituito con controlled value)
    // 1.1.0.512
    // 1.1.0.513 (elimina flash numero grezzo Professione)
    // 1.1.0.514 (loader campo Professione)
    // 1.1.0.515 (loader a tutta pagina, poi sostituito)
    // 1.1.0.516
    // 1.1.0.517 (fix PDF Professione testo libero)
    // 1.1.0.518 (gestione ID orfani Professione)
    // 1.1.0.519 (fix race condition Nazione, incompleto)
    // 1.1.0.520 (fix race condition risposte getData fuori ordine)
    // 1.1.0.521 (fix filtro ricerca Solo primo/secondo anno)
    // 1.1.0.522 (nota Ricerca default Italia, posizione errata)
    // 1.1.0.523 (clear float nota, troppo spazio)
    // 1.1.0.524 (ancora troppo spazio)
    // 1.1.0.525 (titolo+pulsanti stessa riga)
    // 1.1.0.526 (nota anche in Tipografia)
    // 1.1.0.527 (titolo+pulsanti stessa riga anche in members/Form)
    // 1.1.0.528 (nasconde h4 vuoto, ancora spazio)
    // 1.1.0.529 (rimuove breadcrumb Tesseramento in Tipografia)
    // 1.1.0.530 (fix filtro ricerca Entrambi gli anni/both)
    // 1.1.0.531 (export Tipografia: Provincia come sigla, non nome esteso)

    , version: '1.1.0.531'
    , headerCommandIconSize: 36
    , tableCommandIconSize: 18

    , homeIconSize: 75
    , headerIconSize: 30

    , modalHeaderIconSize: 90
}

/** Stati risposta gateway pagamenti / ricevute (useFileToolkit, ecc.) */
export const vendors = {
  transaction_status: {
    completed: "completed",
  },
};

export enum sliceStateStatus {
    idle = 'idle',
    pending = 'pending',
    fulfilled = 'fulfilled',
    rejected = 'rejected'
}


export enum snackbarVariant {
    error = 'error',
    info = 'info',
    success = 'success',
    warning = 'warning'
}

/*
export enum systemRoles {
    admin = 'ROLE_ADMIN',
    user = 'ROLE_USER',
    editor = 'ROLE_EDITOR',
    hero = 'SUPER_HERO'
}
*/

export const systemStatus = {
    active: 'STATUS_ACTIVE',
    inactive: 'STATUS_INACTIVE',
    open: 'STATUS_OPEN',
    closed: 'STATUS_CLOSED',
    deleted: 'STATUS_DELETED',
    added: 'STATUS_ADDED',
    edited: 'STATUS_EDITED'
}

export enum appSections {
    accounts = "SEC_ACCOUNTS",
    users = "SEC_USERS"
}


export enum settingsSections {
    users = "users",
    accounts = "accounts",
}

export enum spinnerAnimation { border = 'border',  grow = 'grow' }

export enum interfaceType {
//   user = 'user',
//   votation = 'votation',
//   activity = 'activity',
//   attachment = 'attachment',
//   news = 'news',
//   file = 'file',
//   password = 'password',
//   contact = 'contact',
//   activityAttachment = "activityAttachment",
//   tab = "tab",
//   faq = "faq",
//   notice = "notice",
//   publicRole = "publicRole",
//   signaturesActivity = "signaturesActivity",
//   search = "search",
//   pagination = 'pagination',
//   post = 'post',
//   comment = 'comment',
  email = 'email'
}

export enum sections {
  email = "email",
}